module.exports = __webpack_public_path__ + "static/img/six.9a29d2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/six.png
// module id = HwB7
// module chunks = 1